"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _phoneInput = _interopRequireDefault(require("./phoneInput"));
var _dateTime = _interopRequireDefault(require("./dateTime"));
var _select = _interopRequireDefault(require("./select"));
var _coloredCheckbox = _interopRequireDefault(require("./coloredCheckbox"));
var _dateSinglePicker = _interopRequireDefault(require("./dateSinglePicker"));
var _timePicker = _interopRequireDefault(require("./timePicker"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * PhoneNumberInputField
 * @param {Object} param The param of phone field
 * @return {Element} React element
 */
var renderPhoneNumberInput = function renderPhoneNumberInput(param) {
  var input = param.input,
    placeholder = param.placeholder,
    internationalPhoneSupportEnabled = param.internationalPhoneSupportEnabled;
  var _param$meta = param.meta,
    error = _param$meta.error,
    touched = _param$meta.touched;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_phoneInput.default, (0, _extends2.default)({}, input, param, {
    placeholder: placeholder,
    hasError: touched && error,
    internationalPhoneSupportEnabled: internationalPhoneSupportEnabled
  })), touched && error && /*#__PURE__*/_react.default.createElement("span", {
    className: "error-msg"
  }, error));
};

/**
 * render input field
 * @param {Object} param
 * @return {Element} React element
 */
var renderInputField = function renderInputField(params) {
  var _params$meta = params.meta,
    touched = _params$meta.touched,
    error = _params$meta.error;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "input-field ".concat((touched && error || params.isInlineError) && 'error-field')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, (0, _extends2.default)({
    placeholder: ""
  }, params.input, params)), touched && error && error !== 'empty' && /*#__PURE__*/_react.default.createElement("span", {
    className: "error-msg"
  }, error));
};
var renderInputOutdatableField = function renderInputOutdatableField(params) {
  var _params$meta2 = params.meta,
    touched = _params$meta2.touched,
    error = _params$meta2.error;
  var outdated = params.outdated;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "input-field ".concat(touched && error && 'error-field', " ").concat(outdated && 'error-field')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, (0, _extends2.default)({
    placeholder: ""
  }, params.input, params)), touched && error && error !== 'empty' && /*#__PURE__*/_react.default.createElement("span", {
    className: "error-msg"
  }, error));
};
/**
 * render number input field
 * @param {Object} param
 * @return {Element} React element
 */
var renderNumberInputField = function renderNumberInputField(params) {
  var _params$meta3 = params.meta,
    touched = _params$meta3.touched,
    error = _params$meta3.error;
  var onChange = function onChange(e) {
    var re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      params.input.onChange(e.target.value);
    }
    return '';
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "input-field ".concat((touched && error || params.isInlineError) && 'error-field')
  }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
    className: "input-number",
    placeholder: ""
  }, params.input, params, {
    onChange: onChange
  })), touched && error && error !== 'empty' && /*#__PURE__*/_react.default.createElement("span", {
    className: "error-msg"
  }, error));
};

/**
 * render text area field
 * @param {Object} param
 * @return {Element} React element
 */
var renderTextAreaField = function renderTextAreaField(params) {
  var _params$meta4 = params.meta,
    touched = _params$meta4.touched,
    error = _params$meta4.error;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "text-area-field ".concat((touched && error || params.isInlineError) && 'error-field')
  }, /*#__PURE__*/_react.default.createElement("textarea", (0, _extends2.default)({
    placeholder: ""
  }, params.input, params)), touched && error && /*#__PURE__*/_react.default.createElement("span", {
    className: "error-msg"
  }, error));
};

/**
 * render text selected field
 * @param {Object} param
 * @return {Element} React element
 */
var renderTextSelectedField = function renderTextSelectedField(params) {
  var input = params.input,
    options = params.options;
  var value = input.value;
  var engagementChecked = options.find(function (i) {
    return value === i.value;
  });
  return /*#__PURE__*/_react.default.createElement("div", null, engagementChecked ? engagementChecked.label : 'Not Applicable (N/A)');
};

/**
 * render select field
 * @param {Object} params
 */
var renderSelectField = function renderSelectField(params) {
  var _params$meta5 = params.meta,
    touched = _params$meta5.touched,
    error = _params$meta5.error,
    warning = _params$meta5.warning;
  var ishasError = (touched || params.isNoNeedTouched) && error || params.isInlineError;
  var isHasWarning = (touched || params.warningNoNeedTouched) && warning;
  var className = '';
  if (params.creatable) {
    className = 'creatable-select-field';
  } else {
    className = params.multi ? 'multi-select-field' : 'select-field';
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(ishasError && 'error-field', " ").concat(!ishasError && isHasWarning && 'warning-field', " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement(_select.default, (0, _extends2.default)({
    placeholder: ""
  }, params)), ishasError && /*#__PURE__*/_react.default.createElement("span", {
    className: "error-msg"
  }, error), !ishasError && isHasWarning && /*#__PURE__*/_react.default.createElement("span", {
    className: "warning-msg"
  }, warning));
};
var renderOutdatedSelectField = function renderOutdatedSelectField(params) {
  var _params$meta6 = params.meta,
    touched = _params$meta6.touched,
    error = _params$meta6.error;
  var outdated = params.outdated;
  var ishasError = (touched || params.isNoNeedTouched) && error;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(ishasError ? 'error-field' : '', " ").concat(outdated ? 'error-field' : '', "\n        ").concat(params.multi ? 'multi-select-field' : 'select-field')
  }, /*#__PURE__*/_react.default.createElement(_select.default, (0, _extends2.default)({
    placeholder: ""
  }, params)), ishasError && /*#__PURE__*/_react.default.createElement("span", {
    className: "error-msg"
  }, error));
};

/**
 * render creatable select field
 * @param {Object} param
 * @return {Element} React element
 */
var renderCreatableSelectField = function renderCreatableSelectField(params) {
  return renderSelectField(_objectSpread(_objectSpread({
    placeholder: '',
    createOptionPosition: 'first',
    customCreateLabel: 'Create new name',
    creatable: true
  }, params), {}, {
    searchable: true
  }));
};

/**
 * Render date time field
 * @param {Object} params
 */
var renderDateTimeField = function renderDateTimeField(params) {
  var _params$meta7 = params.meta,
    error = _params$meta7.error,
    touched = _params$meta7.touched,
    warning = _params$meta7.warning;
  var waringClassName = warning ? 'warning-field' : '';
  var errorClassName = touched && error || params.isInlineError ? 'error-field' : '';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(errorClassName, " ").concat(waringClassName, " datetime-picker-field")
  }, /*#__PURE__*/_react.default.createElement(_dateTime.default, (0, _extends2.default)({}, params.input, params, {
    inputProps: {
      placeholder: params.placeholder
    },
    clearable: true
  })), touched && error && /*#__PURE__*/_react.default.createElement("span", {
    className: "error-msg"
  }, error), warning && /*#__PURE__*/_react.default.createElement("span", {
    className: "warning-msg"
  }, warning));
};
/**
 * Render field
 */
var renderField = function renderField(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    key: "".concat(props.title),
    className: "info-line ".concat(props.className, " ").concat(props.title)
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.ControlLabel, {
    className: "control-label"
  }, props.title, props.isRequired && /*#__PURE__*/_react.default.createElement("span", {
    className: "star-mark"
  }, "*"), props.tooltip), props.field);
};

/**
 * render Checkbox Field
 * @param {Object} param
 * @return {Element} React element
 */
var renderCheckboxField = function renderCheckboxField(params) {
  var _params$meta8 = params.meta,
    touched = _params$meta8.touched,
    error = _params$meta8.error;
  var isCheked = params.input && params.input.value || params.isCheckTimeSetUp;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "check-box-field ".concat(touched && error && 'error-field')
  }, /*#__PURE__*/_react.default.createElement(_coloredCheckbox.default, (0, _extends2.default)({
    key: params.label,
    name: params.label,
    checked: isCheked
  }, params.input, params), params.label), touched && error && /*#__PURE__*/_react.default.createElement("span", {
    className: "error-msg"
  }, error));
};
/**
 * Render date single picker field
 * @param {Object} params
 */
var renderDateSinglePicker = function renderDateSinglePicker(params) {
  var _params$meta9 = params.meta,
    error = _params$meta9.error,
    touched = _params$meta9.touched;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(touched && error && 'error-field', " date-single-picker-field")
  }, /*#__PURE__*/_react.default.createElement(_dateSinglePicker.default, (0, _extends2.default)({}, params.input, params)), touched && error && /*#__PURE__*/_react.default.createElement("span", {
    className: "error-msg"
  }, error));
};
/**
 * Render time single picker field
 * @param {Object} params
 */
var renderTimeSinglePicker = function renderTimeSinglePicker(params) {
  var _params$meta10 = params.meta,
    error = _params$meta10.error,
    touched = _params$meta10.touched;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(touched && error && 'error-field', " date-single-picker-field")
  }, /*#__PURE__*/_react.default.createElement(_timePicker.default, (0, _extends2.default)({}, params.input, params)), touched && error && /*#__PURE__*/_react.default.createElement("span", {
    className: "error-msg"
  }, error));
};
renderField.propTypes = {
  title: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  field: _propTypes.default.element.isRequired,
  isRequired: _propTypes.default.bool,
  tooltip: _propTypes.default.element
};
renderField.defaultProps = {
  isRequired: false,
  className: '',
  tooltip: null
};
var _default = {
  renderPhoneNumberInput: renderPhoneNumberInput,
  renderCreatableSelectField: renderCreatableSelectField,
  renderInputField: renderInputField,
  renderInputOutdatableField: renderInputOutdatableField,
  renderOutdatedSelectField: renderOutdatedSelectField,
  renderSelectField: renderSelectField,
  renderField: renderField,
  renderTextAreaField: renderTextAreaField,
  renderDateTimeField: renderDateTimeField,
  renderTextSelectedField: renderTextSelectedField,
  renderNumberInputField: renderNumberInputField,
  renderCheckboxField: renderCheckboxField,
  renderDateSinglePicker: renderDateSinglePicker,
  renderTimeSinglePicker: renderTimeSinglePicker
};
exports.default = _default;